module.exports = __webpack_public_path__ + "static/media/instagram.59961576.svg";